// VeenaDoc.jsx
import React from 'react'
import { useEffect } from 'react'
import "./veenadoc.css"
import { useNavigate } from 'react-router-dom' // <-- Add this import
import "./veenadoc.css"
import veenadoc from '../../../../assets/images/Doctorsimages/dr.veena.png'
import favicon from "./../../../../assets/images/favicon.ico"
import AutoScrollImageRow from '../../AdvancedTreatmentsforHome/AutoScrollImageRow'
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';


const VeenaDoc = () => {
  const navigate = useNavigate(); 
   useEffect(() => {
       document.title = "Dr. Veena M | Best Homeopathy & Aesthetic Doctor in Jayanagar Bangalore & Chennai";
       const metaDescription = document.querySelector("meta[name='description']");
       if (metaDescription) {
         metaDescription.setAttribute(
           "content",
           "Consult Dr. Veena M (BHMS, FMC), a trusted homeopathy and aesthetic doctor in Jayanagar, Bangalore & Chennai. Expert in skin, hair, acne, pigmentation, and holistic treatments with 4+ years of experience. Book consultation today."
         );
       }
       const metaKeywords = document.querySelector("meta[name='keywords']");
     if (metaKeywords) {
  metaKeywords.setAttribute(
    "content",
    "best homeopathy doctor in Bangalore, homeopathy doctor in Jayanagar Bangalore, aesthetic doctor in Bangalore, female homeopathy doctor in Bangalore, skin specialist in Jayanagar Bangalore, best doctor for acne and pimples in Bangalore, doctor for hair fall treatment in Bangalore, homeopathy doctor for hair fall treatment in Bangalore, homeopathy doctor for skin pigmentation in Bangalore, holistic homeopathy doctor in Chennai, aesthetic skin and hair treatments in Chennai, top homeopathy doctor in Jayanagar Bangalore, consultant homeopathy doctor near me, consultant Skin doctor near me, consultant prp doctor near me, consultant gfc doctor near me"
  );
}

        // Set canonical link
        const existingCanonical = document.querySelector("link[rel='canonical']");
        if (existingCanonical) {
          existingCanonical.setAttribute("href", "https://www.h-cura.com/doctors/dr-veena-m-homeopathy-aesthetics-bangalore");
        } else {
          const canonicalLink = document.createElement("link");
          canonicalLink.setAttribute("rel", "canonical");
          canonicalLink.setAttribute("href", "https://www.h-cura.com/doctors/dr-veena-m-homeopathy-aesthetics-bangalore");
          document.head.appendChild(canonicalLink);
        }
        // Set favicon
     const existingFavicon = document.querySelector("link[rel='icon']");
     if (existingFavicon) {
       existingFavicon.setAttribute("href", favicon);
     } else {
       const faviconLink = document.createElement("link");
       faviconLink.setAttribute("rel", "icon");
       faviconLink.setAttribute("type", "image/x-icon");
       faviconLink.setAttribute("href", favicon);
       document.head.appendChild(faviconLink);
     }
     }, []);

const handleDownloadPdf = () => {
  const container = document.querySelector('.veenadoc');

  // Add PDF-specific class to container
  container.classList.add('veenadoc-pdf-mode');

  // Store original styles
  const originalStyles = new Map();

  // Temporarily modify styles for PDF capture
  const allElements = container.querySelectorAll('*');
  allElements.forEach(el => {
    originalStyles.set(el, {
      transition: el.style.transition,
      animation: el.style.animation,
      transform: el.style.transform,
      filter: el.style.filter
    });

    el.style.transition = 'none';
    el.style.animation = 'none';
    el.style.transform = 'none';
    el.style.filter = 'none';
  });

  // Fix hero section height for PDF
  const heroSection = container.querySelector('.veenadoc-hero-section');
  if (heroSection) {
    heroSection.style.minHeight = 'auto';
    heroSection.style.padding = '40px 0';
  }

  // Ensure images are fully loaded and visible
  const images = container.querySelectorAll('img');
  images.forEach(img => {
    img.style.opacity = '1';
  });

  // Wait a moment for styles to apply
  setTimeout(() => {
    html2canvas(container, {
      scale: 2,
      dpi: 300,
      useCORS: true,
      allowTaint: true,
      letterRendering: true,
      backgroundColor: '#ffffff',
      logging: false,
      windowWidth: container.scrollWidth,
      windowHeight: container.scrollHeight,
      scrollY: -window.scrollY,
      scrollX: -window.scrollX,
      imageTimeout: 0,
      removeContainer: false
    }).then(canvas => {
      // Remove PDF-specific class
      container.classList.remove('veenadoc-pdf-mode');

      // Restore original styles
      allElements.forEach(el => {
        const original = originalStyles.get(el);
        el.style.transition = original.transition;
        el.style.animation = original.animation;
        el.style.transform = original.transform;
        el.style.filter = original.filter;
      });

      // Restore hero section
      if (heroSection) {
        heroSection.style.minHeight = '';
        heroSection.style.padding = '';
      }

      const imgData = canvas.toDataURL('image/jpeg', 0.95);
      const pdf = new jsPDF('p', 'mm', 'a4', true);

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;

      // Define margins for the PDF
      const marginLeft = 10; // 10mm gap on the left
      const marginRight = 10; // 10mm gap on the right to maintain symmetry and prevent cutting
      const availableWidth = pdfWidth - marginLeft - marginRight;

      // Calculate scaling factor to fit the canvas content within the available width
      const scaleFactor = availableWidth / canvasWidth;

      // Apply the scale factor to both width and height to maintain aspect ratio
      const imgWidth = canvasWidth * scaleFactor;
      const imgHeight = canvasHeight * scaleFactor;

      // Calculate the number of pages needed for vertical content overflow
      const pages = Math.ceil(imgHeight / pdfHeight);

      for (let i = 0; i < pages; i++) {
        if (i > 0) {
          pdf.addPage();
        }
        // Add image to PDF, using marginLeft for the x coordinate
        pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
      }

      pdf.save('Dr.Veena_M_Profile.pdf');
    }).catch(error => {
      console.error('Error generating PDF:', error);
      alert('Failed to generate PDF. Please try again.');

      // Remove PDF-specific class
      container.classList.remove('veenadoc-pdf-mode');

      // Restore hero section
      if (heroSection) {
        heroSection.style.minHeight = '';
        heroSection.style.padding = '';
      }

      allElements.forEach(el => {
        const original = originalStyles.get(el);
        if (original) {
          el.style.transition = original.transition;
          el.style.animation = original.animation;
          el.style.transform = original.transform;
          el.style.filter = original.filter;
        }
      });
    });
  }, 100);
};








  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes">
              <div className="veenadoc-shape veenadoc-shape-1"></div>
              <div className="veenadoc-shape veenadoc-shape-2"></div>
              <div className="veenadoc-shape veenadoc-shape-3"></div>
              <div className="veenadoc-shape veenadoc-shape-4"></div>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. Veena M</span>
                  <span className="veenadoc-title-credentials">(BHMS, FMC)</span>
                  <span className="veenadoc-title-location">Bangalore & Chennai</span>
                </h1>

                <div className="veenadoc-hero-description">
                  <p>
                    Recognised as one of the best homoeopathy doctors in Bangalore and a trusted aesthetic doctor in Jayanagar 
                    who provides holistic treatment for both health and cosmetic concerns. With more than <strong>4</strong> years of clinical 
                    experience, she has built a reputation as a compassionate female homoeopathic doctor who combines natural 
                    remedies with modern aesthetic care.
                  </p>
                </div>

                <div className="veenadoc-hero-actions">
                  <button
              className="veenadoc-btn-primary-gradient"
              onClick={() => navigate('/bookconsultation')} // <-- Add this handler
            >
              <span className="veenadoc-btn-icon">📞</span>
              <span>Book Consultation</span>
              <div className="veenadoc-btn-shine"></div>
            </button>
                  {/* <button className="veenadoc-btn-outline-premium">
                    <span className="veenadoc-btn-icon">📍</span>
                    <span>Find Locations</span>
                  </button> */}
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      <img src={veenadoc} alt="Dr. Veena M - Best Homeopathy & Aesthetic Doctor in Jayanagar Bangalore" className="veenadoc-doctor-image" title='Dr. Veena M – Best Homeopathy & Aesthetic Doctor in Jayanagar Bangalore' />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">

              {/* Main Article Content */}
              <div className="veenadoc-article-main">

                {/* Introduction */}
                <div className="veenadoc-article-block">
                  <h2>About Dr. Veena M</h2>
                  <p>
                    Dr. Veena M completed her graduation from the prestigious Government Homoeopathic Medical College and Hospital, 
                    Bangalore, and later pursued a Fellowship in Medical Cosmetology (FMC), making her a highly sought-after 
                    homoeopathy doctor for skin and hair treatments in Bangalore and Chennai.
                  </p>
                  <p>
                    Patients searching for the top homoeopathy doctor in Jayanagar, Bangalore often choose Dr. Veena because of 
                    her patient-focused approach and the proven results she delivers. She has successfully treated patients suffering 
                    from chronic health issues, lifestyle disorders, hair loss, and skin conditions.
                  </p>
                </div>

                {/* Clinical Journey */}
                <div className="veenadoc-article-block">
                  <h2>Clinical Journey & Professional Contributions</h2>
                  <p>
                    Dr. Veena's clinical journey includes working at reputed homoeopathy and aesthetic clinics, where she has 
                    treated a diverse range of cases with successful outcomes. Beyond her practice, she contributes to the 
                    profession as a trainer and case review doctor, mentoring young doctors to deliver quality patient care.
                  </p>
                  <p>
                    Patients often search for a homoeopathic consultant "homoeopathy doctor near me" when they want a professional 
                    who not only provides remedies but also focuses on lifestyle correction, nutrition, and long-term wellness. 
                    Dr. Veena fulfils that role by combining traditional homoeopathy with modern clinical knowledge.
                  </p>
                </div>

               
                     <div className="veenadoc-sidebar-card">
                  <h3>Quick Information</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Qualification:</span>
                      <span className="veenadoc-info-value">BHMS, FMC</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Experience:</span>
                      <span className="veenadoc-info-value">4+ Years</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Specialization:</span>
                      <span className="veenadoc-info-value">Homeopathy & Aesthetics</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Locations:</span>
                      <span className="veenadoc-info-value">Bangalore & Chennai</span>
                    </div>
                  </div>
                </div>
                {/* Expertise in Chronic Conditions */}
                <div className="veenadoc-article-block">
                  <h2>Expertise in Chronic Conditions</h2>
                  <p>
                    One of her areas of expertise is treating chronic conditions with homoeopathy. Patients dealing with thyroid 
                    disorders, hormonal imbalances, migraines, allergies, or lifestyle-induced problems frequently turn to her 
                    when searching for the best homoeopathic doctor for chronic diseases in Bangalore.
                  </p>
                  <p>
                    She takes time to understand the patient's history, underlying triggers, and emotional health before 
                    prescribing personalised remedies. This method ensures lasting improvement and sets her apart from other 
                    practitioners.
                  </p>
                </div>

                {/* Aesthetic Medicine */}
                <div className="veenadoc-article-block">
                  <h2>Leading Aesthetic Doctor in Bangalore</h2>
                  <p>
                    Alongside her homoeopathy practice, Dr. Veena has established herself as a leading aesthetic doctor in 
                    Bangalore, specialising in skin rejuvenation, pigmentation removal, acne and pimples management, and scar 
                    reduction. Many patients searching for the best doctor for acne and pimples treatment in Bangalore find 
                    relief under her guidance.
                  </p>
                  <p>
                    She combines safe homoeopathic remedies with aesthetic procedures that restore skin health without harmful 
                    side effects. Similarly, those struggling with melasma, tanning, or uneven skin tone often approach her as 
                    a trusted homeopathy doctor for skin pigmentation in Bangalore and Chennai.
                  </p>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Specialized Trichology & Hair Care Solutions</h2>
                  <p>
                    Dr. Veena has gained recognition as a trichology doctor in Bangalore specializing in hair fall,  dandruff, scalp conditions, hair thinning, premature greying, alopecia, and hair regrowth treatments. She also provides advanced hair therapies such as PRP (Platelet-Rich Plasma), GFC (Growth Factor Concentrate), Mesotherapy, Stem Cell Therapy, Laser Hair Therapy and exosome  to ensure effective and long-lasting results.
                  </p>
                  <p>
                    Her expertise ensures that patients not only regain healthy hair but also confidence and peace of mind.
                  </p>
                </div>

                {/* Anti-Aging Solutions */}
                <div className="veenadoc-article-block">
                  <h2>Anti-Aging & Aesthetic Treatments</h2>
                  <p>
                    Her expertise also extends to anti-ageing solutions. As patients search for aesthetic treatments in Jayanagar 
                    Bangalore, they often discover her reputation for offering non-invasive therapies that improve skin elasticity, 
                    reduce wrinkles, and promote youthful radiance.
                  </p>
                  <p>
                    She believes that external beauty is best preserved when internal health is maintained, which is why her 
                    aesthetic treatments are always supported by holistic health guidance.
                  </p>
                </div>

                {/* Hair Care Expertise */}
                <div className="veenadoc-article-block">
                  <h2>Comprehensive Hair Care Solutions</h2>
                  <p>
                    Hair care is another area where Dr. Veena has become a trusted name. Patients frequently look for the best 
                    homeopathy doctor for hair fall in Bangalore, and she provides effective treatments that address hair thinning, 
                    dandruff, scalp infections, and premature greying.
                  </p>
                  <p>
                    By focusing on the underlying cause—whether it is stress, nutrition, or hormonal imbalance—she ensures 
                    long-lasting results. This approach has made her one of the most recommended homeopathy doctors for hair 
                    regrowth in Jayanagar Bangalore.
                  </p>
                </div>

                {/* Chennai Practice */}
                <div className="veenadoc-article-block">
                  <h2>Expanding Care to Chennai</h2>
                  <p>
                    Her clinic also attracts patients from Chennai, where she is recognised as a holistic homeopathy doctor in 
                    Chennai who provides comprehensive care for skin, hair, and lifestyle-related concerns. Patients searching 
                    for aesthetic skin and hair treatments in Chennai often consult her for safe, natural, and result-oriented 
                    solutions.
                  </p>
                  <p>
                    Her reputation is steadily growing across both Bangalore and Chennai, making her a trusted doctor for patients 
                    in multiple locations.
                  </p>
                </div>

                {/* Dual Expertise */}
                <div className="veenadoc-article-block">
                  <h2>What Makes Dr. Veena Unique</h2>
                  <p>
                    What makes Dr. Veena unique is her dual expertise in homeopathy and aesthetics. While many doctors specialize 
                    in only one field, she integrates both seamlessly. This dual specialisation ensures that her patients don't 
                    just receive cosmetic improvements but also achieve long-term health benefits.
                  </p>
                  <p>
                    Whether someone is searching for the best homeopathy doctor for holistic treatments in Bangalore, the top 
                    aesthetic doctor in Jayanagar, or a female skin specialist in Bangalore, Dr. Veena's profile appears as a 
                    reliable choice because of her results-driven yet patient-friendly approach.
                  </p>
                </div>

                {/* Online Presence & Patient Queries */}
                <div className="veenadoc-article-block">
                  <h2>Meeting Patient Needs Online</h2>
                  <p>
                    Her growing popularity online is also due to the fact that she matches the most common search queries patients 
                    use. For instance, people often search for:
                  </p>
                  <ul className="veenadoc-search-queries-list">
                    <li>Best homeopathy doctor in Bangalore for chronic diseases</li>
                    <li>Acne and pigmentation treatment in Jayanagar Bangalore</li>
                    <li>Hair fall treatment with homeopathy in Bangalore</li>
                    <li>Aesthetic doctor for anti-aging in Chennai</li>
                    <li>Holistic homeopathy doctor near me</li>
                  </ul>
                  <p>
                    Her expertise aligns perfectly with these queries, ensuring that patients find the care they need quickly 
                    and effectively.
                  </p>
                </div>

                {/* Patient Testimonials */}
                <div className="veenadoc-article-block">
                  <h2>Patient Experience & Reviews</h2>
                  <p>
                    Patients who consult Dr. Veena appreciate her empathetic nature, careful listening, and detailed analysis. 
                    Many reviews describe her as approachable, professional, and highly effective in providing treatments that 
                    deliver visible and long-lasting results.
                  </p>
                  <p>
                    Her strong reputation for combining medical knowledge with personal care has made her one of the most trusted 
                    names in homeopathy and aesthetics.
                  </p>
                </div>

                {/* Conclusion */}
                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>Choose Dr. Veena M for Complete Wellness</h2>
                  <p>
                    Choosing Dr. Veena M means selecting a doctor who is committed to your complete health and well-being. She 
                    provides the assurance of safe treatments, the expertise of modern aesthetic science, and the compassion of 
                    a holistic healer.
                  </p>
                  <p>
                    For anyone searching for the best homeopathy and aesthetic doctor in Bangalore or Chennai, or specifically 
                    looking for the top homeopathy doctor in Jayanagar for skin and hair treatments, Dr. Veena is the doctor 
                    who brings together trust, expertise, and results.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>Her mission:</strong> To empower patients with healthier lives, glowing skin, stronger hair, and 
                    renewed confidence.
                  </p>
                </div>

              </div>

              {/* Sidebar */}
              <div className="veenadoc-article-sidebar">

                {/* Philosophy of Care */}
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">💫</div>
                    <blockquote>
                      "Treating every patient in a holistic approach"
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. Veena M's Philosophy of Care</p>
                  </div>
                  <p>
                    She believes that true healing goes beyond temporary relief of symptoms and requires addressing the root 
                    cause of illness. This patient-centric approach has positioned her among the best holistic homoeopathy 
                    doctors in Bangalore and Chennai, where she provides customised treatments for individuals of all age groups.
                  </p>
                </div>

                {/* Services */}
                {/* <div className="veenadoc-sidebar-card">
                  <h3>Treatment Areas</h3>
                  <ul className="veenadoc-services-list">
                    <li>🌿 Chronic Diseases</li>
                    <li>🦋 Thyroid Disorders</li>
                    <li>💆‍♀️ Hormonal Imbalances</li>
                    <li>🧠 Migraines & Allergies</li>
                    <li>✨ Skin Rejuvenation</li>
                    <li>🎯 Acne & Pigmentation</li>
                    <li>💇‍♀️ Hair Fall Treatment</li>
                    <li>⏰ Anti-Aging Solutions</li>
                  </ul>
                </div> */}

                {/* Locations */}
                <div className="veenadoc-sidebar-card">
                  <h3>Practice Locations</h3>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>Jayanagar, Bangalore</h4>
                      <p>Primary practice location</p>
                    </div>
                  </div>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>Chennai</h4>
                      <p>Extended care services</p>
                    </div>
                  </div>
                </div>

                {/* Contact CTA */}
                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Book Your Consultation</h3>
                  <p>Experience holistic healthcare with Dr. Veena's personalized approach.</p>
                 <button
                  className="veenadoc-sidebar-btn-primary"
                  onClick={() => window.location.href = 'tel:+919964688333'}
                >
                  <span>📞</span>
                  <span>Schedule Appointment</span>
                </button>
                <button
                  className="veenadoc-sidebar-btn-secondary"
                  onClick={() => window.location.href = 'tel:+919964688333'}
                >
                  <span>💬</span>
                  <span>Get Free Assessment</span>
                </button>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>

      <AutoScrollImageRow/>

       <div className="bangloregfcblog-download-section">
            <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
              Download This Doctor profile as PDF
            </button>
          </div>
    </>
  )
}

export default VeenaDoc


